define('score_bootstrap/Models/Search/SimpleSearchClient',[
    "jquery",
    "errorHandler",
    "score_bootstrap/Models/Search/SearchRequest"
], function ($, errorHandler, SearchRequest) {

    function SimpleSearchClient(searchUrl, perPage, language, root, indexName, templates, startPage, page, tileNames, component) {
        var searchRequest = new SearchRequest();

        if (perPage !== undefined) searchRequest.perPage = perPage;
        if (language) searchRequest.language = language;
        if (root !== undefined) searchRequest.root = root;
        if (indexName !== undefined) searchRequest.indexName = indexName;
        if (templates !== undefined) searchRequest.templates = templates;
        if (page !== undefined) searchRequest.page = page;
        if (startPage !== undefined) searchRequest.startPage = startPage;
        if (component !== undefined) searchRequest.component = component;

        // we can accept a single string or an array or strings
        if (tileNames) {
            typeof (tileNames) === "string"
                ? searchRequest.addTileRequest(tileNames)
                : tileNames.forEach(searchRequest.addTileRequest);
        }

        Object.defineProperties(this, {
            searchRequest: { value: searchRequest },
            searchUrl: { value: searchUrl }
        });
    }

    SimpleSearchClient.prototype.search = function search() {
        var jqXHR = $.ajax({
            url: this.searchUrl,
            data: JSON.stringify(this.searchRequest),
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json"
        });
        
        jqXHR.fail(errorHandler.logError);

        return jqXHR;
    }

    return SimpleSearchClient;
});
